<template>
  <v-app @click.native="saveUserActivityTime" style="padding-left: 80px;">
    <v-app-bar app style="background-color:#0031e2; color: white; padding-left: 80px; height: 64px; ">
      <v-toolbar-title style="position: relative; top: 4px; width: 500px">
        <v-row>
          <div style="width: 50px;" class="px-3">
            <img v-if="$store.state.Auth.isWntLoaded && $store.state.Auth.isWnt" alt="Logo Why Not Travel" src="/img/logownt.jpg" style="height: 40px;" />
            <img v-if="$store.state.Auth.isWntLoaded && !$store.state.Auth.isWnt" alt="Logo Why Not Travel" src="/img/logofollowup.png" style="height: 40px;" />
          </div>
          <div
            style="    font-weight: 700;
    top: 4px;
    position: relative;
    width: 330px;"
          >
            {{ $t("global.title") }}
          </div>
        </v-row>
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items style="position: relative;" v-if="!isWnbUser && !$store.getters['isAdmin']">
        <v-btn @click="chooseLang('pl')" text>
          <flag :squared="false" iso="pl" style="font-size: 23px;" />
        </v-btn>
        <v-btn @click="chooseLang('en')" text>
          <flag :squared="false" iso="gb" style="font-size: 23px;" />
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <main-menu />
    <v-content>
      <div
        style="position: fixed;
    height: 12px;
    width: 100%;
    z-index: 7;"
      >
        <v-progress-linear :indeterminate="true" color="accent" style="margin: 0" v-if="loading" />
      </div>
      <v-alert type="error" v-if="isBrowserIE">
        {{ $t("global.browserNotCompatible") }}
      </v-alert>
      <v-alert type="warning" v-if="!online">
        {{ $t("global.warning.offline") }}
      </v-alert>
      <v-alert @click="reload" type="info" v-if="update">
        {{ $t("global.newVersionAvailable") }}
      </v-alert>
      <v-container
        class="justify"
        :class="{
          'padding-main-container': true,
          'main-container': !$store.state.Visual.wideView,
          'gray-half-background': halfGrayBackground,
          'gray-menu-background': menuBackground,
          'gray-half-menu-background': halfMenuBackground
        }"
        fluid
      >
        <router-view>
          <slot></slot>
        </router-view>
      </v-container>
    </v-content>
    <div style="align-content: center; text-align: center; margin-bottom: 30px; background-color: white;" v-if="$store.state.Auth.isWnt">
      <a href="https://whynottravel.pl/">
        <img src="/img/banner.gif" />
      </a>
    </div>
    <v-col
      style="align-content: center; text-align: center; margin-bottom: 30px; background-color: white;"
      v-if="$store.state.Auth.isWntLoaded && !$store.state.Auth.isWnt"
    >
      <v-img src="/img/logoeu.png" class="responsive" />
    </v-col>

    <v-footer app style="z-index: 9" v-if="$vuetify.breakpoint.mdAndUp" class="body-2 pa-0">
      <template v-if="$store.state.Auth.isWnt">
        <div class="pull-left">&copy; <a href="http://whynottravel.pl" rel="external">WNT</a> 2019</div>
        <div style="padding-left: 8px; color: darkgray;">
          @
          <a href="http://solvsoft.pl/" rel="external" style="color:darkgray">SolvSoft.pl</a>
          Version 0.36.4 build date 2020-02-26 15:02:58, visual brand Nexocode
        </div>
      </template>
      <template v-else>
        <div class="pull-left">&copy; <a href="https://followup.pl" rel="external">FollowUp</a> 2019</div>
      </template>
      <div style="color: darkgray; position: absolute; right: 8px;" v-if="$store.getters['isAuthenticated']">Inactivity logout: {{ toLogout }}</div>
    </v-footer>
    <confirm-dialog />
    <alert-dialog />
    <snackbar />
    <prompt-dialog />
    <div id="clear-focus-element" style="display: none"></div>
  </v-app>
</template>

<script>
import MainMenu from "./Menu.vue";
import ConfirmDialog from "./Dialog/ConfirmDialog.vue";
import AlertDialog from "./Dialog/AlertDialog.vue";
import detectIe from "../repository/detectIe";

import { authOnVueCreated } from "../../src/store/modules/auth";
import Snackbar from "./Dialog/Snackbar.vue";
import PromptDialog from "./Dialog/PromptDialog";
import main from "../main";

export default {
  name: "App",
  components: { PromptDialog, Snackbar, AlertDialog, ConfirmDialog, MainMenu },
  data: () => ({
    update: false,
    toLogout: null
  }),
  methods: {
    saveUserActivityTime() {
      let time = new Date().getTime() / 1000;
      localStorage.setItem("lastActivityTime", time);
    },
    chooseLang(newLanguage) {
      this.$store.dispatch("CHOOSE_LANGUAGE", newLanguage);
      let isoLanguage = "";
      if (newLanguage === "pl") isoLanguage = "pl-PL";
      if (newLanguage === "en") isoLanguage = "en-US";
      if (this.$store.getters["isAuthenticated"]) {
        this.axios.post("settings/my-profile/update-my-language", {
          language: isoLanguage
        });
      }
    },
    reload() {
      window.location.reload();
    }
  },
  computed: {
    isNewUpdateAvailable() {
      return this.$store.getters["isUpdateAvailable"];
    },
    online() {
      return this.$store.getters["isOnline"];
    },
    isWnbUser() {
      return this.$store.getters["isWnbUser"];
    },
    loading() {
      return this.$store.getters["Ajax/loading"];
    },
    halfGrayBackground() {
      return this.$store.getters["Visual/halfBackground"];
    },
    menuBackground() {
      return this.$store.getters["Visual/menuBackground"];
    },
    halfMenuBackground() {
      return this.$store.getters["Visual/halfMenuBackground"];
    },
    isBrowserIE() {
      return detectIe() !== false && detectIe() < 12; // IE w wersji przed Edge
    }
  },
  created() {
    authOnVueCreated(this).then();
    let self = this;
    setInterval(() => {
      let sessionTime = 30;
      // eslint-disable-next-line
      if (main.$store.getters["userProperties"] !== null && !!main.$store.getters["userProperties"].system_settings) {
        sessionTime = main.$store.getters["userProperties"].system_settings.session_time;
      }
      let dateTime = new Date(parseInt(localStorage.getItem("lastActivityTime")) * 1000 + sessionTime * 60 * 1000);
      let diff = dateTime - new Date();
      let minutesToLogout = Math.floor(diff / 1000 / 60);
      let secondsToLogout = Math.floor((diff - minutesToLogout * 60 * 1000) / 1000);
      if (minutesToLogout < 0 && self.$store.getters["isAuthenticated"]) {
        self.$router.push("/logout");
      }
      self.toLogout = minutesToLogout + ":" + (secondsToLogout < 10 ? "0" + secondsToLogout : secondsToLogout);
    }, 1000);
    self.$store.commit("SET_ONLINE_STATUS", navigator.onLine);
    window.addEventListener("online", function() {
      self.$store.commit("SET_ONLINE_STATUS", true);
    });
    window.addEventListener("offline", function() {
      self.$store.commit("SET_ONLINE_STATUS", false);
    });
    window.addEventListener("availableUpdate", function() {
      self.update = true;
      self.$store.commit("SET_AVAILABLE_UPDATE_STATUS", true);
    });
  }
};
</script>

<style>
.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
}

fieldset.custom-fieldset {
  margin-bottom: 24px;
  padding: 16px 24px 0;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.fieldset-warning {
  border: 4px solid rgba(255, 212, 105, 0.42);
}

.fieldset-warning > legend {
  color: rgb(255, 212, 105);
}

.fieldset-error {
  border: 4px solid rgba(249, 107, 107, 0.42);
}

.fieldset-error > legend {
  color: rgb(249, 107, 107);
}

.custom-fieldset > legend {
  border: 0;
  color: inherit;
  display: table;
  max-width: 100%;
  white-space: normal;
  margin-left: 24px;
  padding: 0 12px;
  font-weight: 700;
  text-transform: uppercase;
}

th {
  color: #0031e2 !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
}

label.v-label {
  font-weight: 700;
  text-transform: uppercase;
}

.theme--light .v-datatable thead th.column.sortable.active i,
.application .theme--light.v-datatable thead th.column.sortable.active i {
  color: #0031e2 !important;
}

.headline {
  font-family: Merriweather, serif !important;
  font-weight: bold;
}

h1 {
  font-family: Merriweather, serif !important;
  font-size: 24px;
  margin: 16px 0;
}

h2 {
  font-family: Merriweather, serif !important;
  /*font-size: 24px;*/
  /*margin: 16px 0;*/
}

@media (min-width: 960px) {
  h1 {
    font-size: 36px;
  }
}

.v-stepper__label {
  /*font-family: Merriweather, serif !important;*/
  font-weight: 700 !important;
}

.v-btn {
  font-weight: 700;
}

@font-face {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  src: local("Roboto"), local("Roboto-Regular"), url(~roboto-fontface/fonts/roboto/Roboto-Regular.woff2) format("woff2"),
    url(~roboto-fontface/fonts/roboto/Roboto-Regular.woff) format("woff");
}

@font-face {
  font-family: Roboto;
  font-style: normal;
  font-weight: 700;
  src: local("Roboto Bold"), local("Roboto-Bold"), url(~roboto-fontface/fonts/roboto/Roboto-Bold.woff2) format("woff2"),
    url(~roboto-fontface/fonts/roboto/Roboto-Bold.woff) format("woff");
}

@font-face {
  font-family: Merriweather;
  font-style: normal;
  font-weight: 700;
  src: local("Merriweather Bold"), local("Merriweather-Bold"), url("../font/merriweather-v19-latin_latin-ext-700.woff2") format("woff2"),
    url("../font/merriweather-v19-latin_latin-ext-700.woff") format("woff");
}

.v-btn.v-btn--icon:hover {
  color: blue;
}

@media (min-width: 960px) {
  .padding-main-container.container {
    padding-top: 70px;
    padding-left: 20px;
    padding-right: 20px;
  }
}

@media (min-width: 1264px) {
  .main-container.container {
    padding-left: calc(25vw - 300px);
    padding-right: calc(25vw - 300px);
  }
}

@media (min-width: 1600px) {
  .main-container.container {
    padding-left: calc(50vw - 700px);
    padding-right: calc(50vw - 700px);
  }
}

@media (max-width: 600px) {
  .v-chip .v-chip__content {
    height: unset;
    white-space: unset;
  }

  .v-chip--small {
    height: unset;
  }
}

.primary--text {
  color: #0031e2 !important;
}

.v-content {
  background-color: white;
}

.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close) {
  /*box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.2), 0px 16px 24px 2px rgba(0,0,0,0.14), 0px 6px 30px 5px rgba(0,0,0,0.12); default*/
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12) !important;
}

.gray-half-background {
  background: linear-gradient(180deg, #eee 310px, #fff 0);
}

.gray-menu-background {
  background: linear-gradient(180deg, #eee 225px, #fff 0);
}

.gray-half-menu-background {
  background: linear-gradient(180deg, #eee 150px, #fff 0);
}

@media (max-width: 960px) {
  .gray-half-background {
    background: linear-gradient(180deg, #eee 240px, #fff 0);
  }

  .gray-menu-background {
    background: linear-gradient(180deg, #eee 155px, #fff 0);
  }

  .gray-half-menu-background {
    background: linear-gradient(180deg, #eee 80px, #fff 0);
  }
}

.choose-box {
  background: white;
  padding: 30px;
  margin: 30px;
  /*height: calc(100% - 60px);*/
}

.v-expansion-panel__header {
  height: auto;
}

.datatable-action-column-field {
  white-space: nowrap;
}

.v-select__selections {
  width: calc(100% - 33px);
}

.datatable-total-amount {
  white-space: nowrap;
  color: #44d3af !important;
  font-weight: bold !important;
}

.sub-menu-item {
  font: bold 16px Merriweather, serif;
  text-transform: none;
}

.sub-menu-item-icon {
  margin-right: 15px;
}

.table-less-padding table tr th:not(:first-child),
.table-less-padding table tr th:first-child {
  padding: 0 12px;
}

.border-positive {
  border: 10px solid rgba(0, 255, 0, 0.2);
}

.border-negative {
  border: 10px solid rgba(255, 0, 0, 0.2);
}

.input-capitalize textarea,
.input-capitalize input {
  text-transform: capitalize;
}

.v-stepper__header {
  height: unset !important;
}

.no-line-after-input.v-input--is-disabled .v-input__slot:before,
.application .no-line-after-input.v-input--is-disabled .v-input__slot:before {
  border-image: none;
  border-style: none;
}

.no-line-after-input.v-input--is-disabled input,
.no-line-after-input.v-input--is-disabled input {
  color: black;
}
.no-line-after-input.v-input--is-disabled input,
.no-line-after-input.v-input--is-disabled input {
  color: black;
}

.wysiwyg table {
  border-collapse: collapse;
}

.wysiwyg table,
.wysiwyg th,
.wysiwyg td {
  border: 1px solid #b7b7b7;
}

.wysiwyg th,
.wysiwyg td {
  padding: 6px;
}

.main-menu-panel .v-list-item--active {
  background: white !important;
  color: #0031e2;
}

.main-menu-panel .v-list-item--active:before {
  opacity: 0;
}

.sortable {
  white-space: nowrap;
}

.v-chip.v-size--default {
  font-size: 13px;
}

.v-dialog .v-card__text {
  text-align: justify;
}
</style>
